import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ManageEmailTemplateService } from "../services/manage-email-template.service";
import { MasterDataService } from "../services/masterdata.service";
declare let $: any;

@Component({
    selector: "app-search-email-template",
    templateUrl: "./search-email-template.component.html",
    styleUrls: ["./search-email-template.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchEmailTemplateComponent implements OnInit {
  templates: any = [];
  filteredTemplates: any = [];
  selectedTemplates: string = "Email_Catagory";
  selectedEmailTitle: string = "";
  emailCatagory: any = [];
  private subscription: Subject<void> = new Subject<void>();
  @ViewChild("updateEmail") updatedEmail: ElementRef;
  sampleColumns: any;
  totalRecords: number;
  showEmailLoader: boolean =true; 
  constructor(
    private manageEmailTemplateService: ManageEmailTemplateService,
    private router: Router,
    private masterDataService: MasterDataService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loadTableData();
    this.allTemplates(true);
  }

  allTemplates(flag) {
    this.manageEmailTemplateService
      .getEmailTemplateData()
      .pipe(takeUntil(this.subscription))
      .subscribe((res) => {
        this.templates = [];
        if (res) {
            res= res.Data;
          res.map((res) => {
            if (res.EmailTemplates_ModifiedDate) {
              let modifyDate = res.EmailTemplates_ModifiedDate.split(" ");
              let modifiedDate = modifyDate[0].split("/");
              modifiedDate = ((modifiedDate[0] > 8) ? (modifiedDate[0]) : ('0' + (modifiedDate[0]))) + '/' + ((modifiedDate[1] > 9) ? modifiedDate[1] : ('0' + modifiedDate[1])) + '/' + modifiedDate[2];

              let modifyTime = modifyDate[1];
              modifyTime = modifyTime.split(":");
              modifyTime = modifyTime[0] + ":" + modifyTime[1];
              modifyDate = modifiedDate + " - " + modifyTime + " " + modifyDate[2] + " CST";

              this.templates.push({
                emailCatagory: res.EmailTemplates_CategoryName,
                emailTitle: res.EmailTemplates_Title,
                editEmail: " ",
                EmailTemplates_ModifiedBy: res.EmailTemplates_ModifiedBy,
                EmailTemplates_ModifiedDate: modifyDate,
                templateId: res.EmailTemplates_ID,
              });
            }
          });
          this.filteredTemplates = this.templates;
          this.emailCatagory = Object.values(
            this.templates.reduce((c, e) => {
              if (!c[e.emailCatagory]) c[e.emailCatagory] = e;
              return c;
            }, {})
          );
          this.reloadPageWithData(flag);
        }
      });
  }

  // for data persist
  setDataOnTabChange() {
    const inputData = {
      selectedTemplates: this.selectedTemplates,
      selectedEmailTitle: this.selectedEmailTitle,
    };
    this.masterDataService.searchEmailModelData = inputData;
  }

  //Fixing clear button issue for bug 2694288
  reloadPageWithData(flag) {
    const tempEmailSearchData = this.masterDataService.searchEmailModelData;
    if(flag){
      if (tempEmailSearchData) {
        this.selectedTemplates = tempEmailSearchData.selectedTemplates
          ? tempEmailSearchData.selectedTemplates
          : "";
        this.selectedEmailTitle = tempEmailSearchData.selectedEmailTitle
          ? tempEmailSearchData.selectedEmailTitle
          : "";
          this.searchFilters(this.selectedTemplates, this.selectedEmailTitle);
    }
  }
    else{
      this.selectedEmailTitle = "";
      this.selectedTemplates = "Email_Catagory";
      this.setDataOnTabChange();
    }
    this.showEmailLoader = false;
  }

  searchFilters(selectedTemplate: string, emailTitle?) {
    this.filteredTemplates = [];
  
      //Changes for filtering records by category if selected
    if(selectedTemplate && selectedTemplate !== "Email_Catagory") { 
      this.filteredTemplates = this.templates.filter(
        (x) =>
          x.emailCatagory != null &&
          x.emailCatagory.toLowerCase() === selectedTemplate.toLowerCase() &&
          x.emailTitle?.toLowerCase().includes(emailTitle.toLowerCase())
      );
    }
    else {
      this.filteredTemplates = this.templates.filter(
        (x) => x?.emailTitle.toLowerCase().includes(emailTitle.toLowerCase())
      );
    }

    this.setDataOnTabChange();
  }

  getfilteredtemplatelist(selectedTemplate: string, emailTitle?) {
    this.selectedEmailTitle = "";
    if (
      selectedTemplate &&
      selectedTemplate !== "" &&
      selectedTemplate !== "Email_Catagory" &&
      emailTitle == undefined
    ) {
      
      //Fix to persist email category for bug 2694288
      this.selectedTemplates = selectedTemplate;
      this.selectedEmailTitle = '';
      this.setDataOnTabChange();
      this.reloadPageWithData(true);
      this.filteredTemplates = this.templates.filter(
        (templates) => templates.emailCatagory === selectedTemplate
      );
     
    } else {
      
      this.filteredTemplates = JSON.parse(JSON.stringify(this.templates));
    }
    this.totalRecords =
      this.filteredTemplates.length > 0 ? this.filteredTemplates.length : 0;
  }

  //Fixing clear button issue for bug 2694288
  clearEmailFields() {
    this.allTemplates(false);
  }

  onRowSelect(rowData) {
    const id = rowData.templateId ? rowData.templateId : null;
    this.router.navigate(["/manageEmailTemplate"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: id },
    });
  }

  loadTableData() {
    this.sampleColumns = [
      {
        name: "emailCatagory",
        header: "Email Category",
        dataType: "string",
        minWidth: "60px",
      },
      {
        name: "emailTitle",
        header: "Email Title",
        dataType: "string",
        minWidth: "100px",
      },     
      {
        name: "EmailTemplates_ModifiedBy",
        header: "Last Modified by",
        dataType: "string",
        minWidth: "60px",
      },
      {
        name: "EmailTemplates_ModifiedDate",
        header: "Date & Time",
        dataType: "string",
        minWidth: "60px",
      },
      {
        name: "editEmail",
        header: "Action",
        dataType: "string",
        minWidth: "60px",
      },
    ];
  }

 

  updateListData(event) {
    console.log(event);
  }

  ngOnDestroy() {
    this.subscription.next();
    this.subscription.complete();
  }
}
